export default __webpack_public_path__ + "static/media/section7-background.4b83ed2d.jpg";